'use client';

import React, { useState, useRef, useCallback, useEffect } from 'react';


// ─── Icons ────────────────────────────────────────────────────────────────────

const EagleIcon = ({ size = 32 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M16 3C9.373 3 4 8.373 4 15c0 3.6 1.55 6.84 4.02 9.1L6.5 28h19l-1.52-3.9A11.97 11.97 0 0 0 28 15C28 8.373 22.627 3 16 3z" fill="url(#eg2)" opacity="0.92"/>
    <path d="M11 15c0-1.38 1.12-2.5 2.5-2.5h5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5h-5C12.12 17.5 11 16.38 11 15z" fill="#1a1200" opacity="0.55"/>
    <path d="M12.5 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM17.5 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z" fill="#1a1200"/>
    <defs>
      <linearGradient id="eg2" x1="4" y1="3" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fbbf24"/>
        <stop offset="1" stopColor="#f59e0b"/>
      </linearGradient>
    </defs>
  </svg>
);

const ShuffleIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22"/>
    <path d="m18 2 4 4-4 4"/><path d="M2 6h1.9c1.5 0 2.9.9 3.6 2.2"/>
    <path d="m18 22 4-4-4-4"/><path d="M21.8 18H20c-1.3 0-2.5-.6-3.3-1.7l-.5-.8"/>
  </svg>
);

const DownloadIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/>
  </svg>
);

const UploadIcon = ({ size = 18 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="17 8 12 3 7 8"/><line x1="12" x2="12" y1="3" y2="15"/>
  </svg>
);

const PlusIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14"/><path d="M12 5v14"/>
  </svg>
);

const TrashIcon = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
  </svg>
);

const ChevronDownIcon = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m6 9 6 6 6-6"/>
  </svg>
);

const ChevronUpIcon = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m18 15-6-6-6 6"/>
  </svg>
);

const LayersIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"/>
    <path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/>
    <path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/>
  </svg>
);

const SparklesIcon = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
    <path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>
  </svg>
);

const InfoIcon = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>
  </svg>
);

const ZipIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5z"/>
    <polyline points="17 2 17 8 23 8"/>
  </svg>
);

const MenuIcon = ({ size = 22 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);

const CloseIcon = ({ size = 22 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
  </svg>
);

const MailIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const MapPinIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);

const RefreshIcon = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
    <path d="M21 3v5h-5"/>
    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
    <path d="M8 16H3v5"/>
  </svg>
);

// ─── Types ────────────────────────────────────────────────────────────────────

interface LayerItem {
  id: string;
  name: string;
  dataUrl: string;
  rarity: number;
}

interface Layer {
  id: string;
  name: string;
  items: LayerItem[];
  collapsed: boolean;
  order: number;
}

// ─── Constants ────────────────────────────────────────────────────────────────

const MAX_LAYERS = 5;

const LAYER_COLORS = [
  { badge: 'layer-badge-1', dot: '#fbbf24', label: 'Gold' },
  { badge: 'layer-badge-2', dot: '#a78bfa', label: 'Violet' },
  { badge: 'layer-badge-3', dot: '#67e8f9', label: 'Cyan' },
  { badge: 'layer-badge-4', dot: '#6ee7b7', label: 'Emerald' },
  { badge: 'layer-badge-5', dot: '#fda4af', label: 'Rose' },
];

const BASE_DEMO_ITEMS: LayerItem[] = [
  { id: 'base-1', name: 'HEADBODY9', dataUrl: '/assets/images/HEADBODY9-1783393215477.png', rarity: 50 },
  { id: 'base-2', name: 'HEADBODY1', dataUrl: '/assets/images/HEADBODY1-1783393215979.png', rarity: 50 },
  { id: 'base-3', name: 'HEADBODY2', dataUrl: '/assets/images/HEADBODY2-1783393215953.png', rarity: 50 },
  { id: 'base-4', name: 'HEADBODY3', dataUrl: '/assets/images/HEADBODY3-1783393215889.png', rarity: 50 },
  { id: 'base-5', name: 'HEADBODY6', dataUrl: '/assets/images/HEADBODY6-1783393215973.png', rarity: 50 },
];

const BEAK_DEMO_ITEMS: LayerItem[] = [
  { id: 'beak-1', name: 'BEAK1', dataUrl: '/assets/images/BEAK1-1783638301293.png', rarity: 50 },
  { id: 'beak-2', name: 'BEAK2', dataUrl: '/assets/images/BEAK2-1783638302017.png', rarity: 50 },
];

const EYES_DEMO_ITEMS: LayerItem[] = [
  { id: 'eyes-1', name: 'EYES1', dataUrl: '/assets/images/EYES1-1783637966045.png', rarity: 50 },
  { id: 'eyes-2', name: 'EYES2', dataUrl: '/assets/images/EYES2-1783637965754.png', rarity: 50 },
  { id: 'eyes-3', name: 'EYES3', dataUrl: '/assets/images/EYES3-1783637966027.png', rarity: 50 },
  { id: 'eyes-4', name: 'EYES4', dataUrl: '/assets/images/EYES4-1783637966590.png', rarity: 50 },
  { id: 'eyes-5', name: 'EYES5', dataUrl: '/assets/images/EYES5-1783637966297.png', rarity: 50 },
];

const BG_COLORS: { name: string; hex: string }[] = [
  { name: 'BG Sky Blue', hex: '#87CEEB' },
  { name: 'BG Sunset Orange', hex: '#FF7043' },
  { name: 'BG Forest Green', hex: '#4CAF50' },
  { name: 'BG Royal Purple', hex: '#7B1FA2' },
  { name: 'BG Golden Yellow', hex: '#FFC107' },
];

const NAV_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Randomizer', href: '#randomizer' },
  { label: 'Collection', href: '#collection' },
  { label: 'Contact', href: '#contact' },
];

function makeSolidColorDataUrl(hex: string, size = 100): string {
  if (typeof document === 'undefined') return '';
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d')!;
  ctx.fillStyle = hex;
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL('image/png');
}

function uid() {
  return Math.random().toString(36).slice(2, 10);
}

function weightedPick(items: LayerItem[]): LayerItem | null {
  if (items.length === 0) return null;
  const total = items.reduce((s, i) => s + i.rarity, 0);
  if (total === 0) return items[Math.floor(Math.random() * items.length)];
  let r = Math.random() * total;
  for (const item of items) {
    r -= item.rarity;
    if (r <= 0) return item;
  }
  return items[items.length - 1];
}

async function compositeImages(picks: (LayerItem | null)[], size = 1000): Promise<string> {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d')!;
  for (const pick of picks) {
    if (!pick) continue;
    await new Promise<void>((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => { ctx.drawImage(img, 0, 0, size, size); resolve(); };
      img.onerror = () => resolve();
      img.src = pick.dataUrl;
    });
  }
  return canvas.toDataURL('image/png');
}

// ─── Auto-Rotating Preview Component ─────────────────────────────────────────

interface AutoPreviewProps {
  layers: Layer[];
}

function AutoPreview({ layers }: AutoPreviewProps) {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const countdownRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const generatePreview = useCallback(async () => {
    const hasItems = layers.some((l) => l.items.length > 0);
    if (!hasItems) return;
    setIsTransitioning(true);
    const picks = layers.map((l) => weightedPick(l.items));
    const url = await compositeImages(picks, 600);
    setPreviewUrl(url);
    setTimeout(() => setIsTransitioning(false), 300);
    setCountdown(10);
  }, [layers]);

  useEffect(() => {
    generatePreview();
  }, []);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      generatePreview();
    }, 10000);
    countdownRef.current = setInterval(() => {
      setCountdown((c) => (c <= 1 ? 10 : c - 1));
    }, 1000);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      if (countdownRef.current) clearInterval(countdownRef.current);
    };
  }, [generatePreview]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
      {/* Preview frame */}
      <div style={{
        position: 'relative',
        width: '100%',
        maxWidth: '420px',
        aspectRatio: '1 / 1',
        borderRadius: '24px',
        overflow: 'hidden',
        border: '2px solid rgba(251,191,36,0.35)',
        boxShadow: '0 0 60px rgba(251,191,36,0.18), 0 24px 64px rgba(0,0,0,0.5)',
      }}>
        {/* Checkerboard bg */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'linear-gradient(45deg,#1e2235 25%,transparent 25%),linear-gradient(-45deg,#1e2235 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#1e2235 75%),linear-gradient(-45deg,transparent 75%,#1e2235 75%)',
          backgroundSize: '20px 20px',
          backgroundPosition: '0 0,0 10px,10px -10px,-10px 0',
          backgroundColor: '#171b2a',
        }} />

        {previewUrl ? (
          <img
            src={previewUrl}
            alt="Auto-generated Regal Eagle NFT combination preview"
            style={{
              position: 'absolute', inset: 0,
              width: '100%', height: '100%',
              objectFit: 'contain',
              opacity: isTransitioning ? 0 : 1,
              transition: 'opacity 0.4s cubic-bezier(0.4,0,0.2,1)',
            }}
          />
        ) : (
          <div style={{
            position: 'absolute', inset: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '64px',
          }}>🦅</div>
        )}

        {/* Countdown ring overlay */}
        <div style={{
          position: 'absolute', bottom: '12px', right: '12px',
          width: '36px', height: '36px',
          borderRadius: '50%',
          background: 'rgba(14,17,27,0.75)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(251,191,36,0.3)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '11px', fontWeight: 700,
          color: '#fbbf24',
          fontFamily: 'var(--font-mono)',
        }}>
          {countdown}s
        </div>

        {/* Live badge */}
        <div style={{
          position: 'absolute', top: '12px', left: '12px',
          display: 'flex', alignItems: 'center', gap: '5px',
          padding: '4px 10px', borderRadius: '99px',
          background: 'rgba(14,17,27,0.75)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(251,191,36,0.25)',
        }}>
          <div style={{
            width: '6px', height: '6px', borderRadius: '50%',
            background: '#4ade80',
            boxShadow: '0 0 6px #4ade80',
            animation: 'pulse-gold 2s ease-in-out infinite',
          }} />
          <span style={{ fontSize: '10px', fontWeight: 700, color: 'rgba(251,191,36,0.9)', letterSpacing: '0.06em' }}>LIVE</span>
        </div>
      </div>

      {/* Refresh button */}
      <button
        onClick={generatePreview}
        style={{
          display: 'flex', alignItems: 'center', gap: '7px',
          padding: '8px 18px', borderRadius: '99px',
          background: 'rgba(251,191,36,0.1)',
          border: '1px solid rgba(251,191,36,0.25)',
          color: '#fbbf24',
          fontSize: '12px', fontWeight: 600,
          cursor: 'pointer',
          transition: 'all 0.2s',
          fontFamily: 'var(--font-sans)',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(251,191,36,0.18)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(251,191,36,0.1)'; }}
      >
        <RefreshIcon size={13} />
        Generate New
      </button>

      <p style={{ fontSize: '11px', color: 'hsl(var(--muted-foreground))', margin: 0, textAlign: 'center' }}>
        Auto-refreshes every 10 seconds with a new random combination
      </p>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────

export default function RegalEaglesPage() {
  const [layers, setLayers] = useState<Layer[]>(() => {
    const bgItems: LayerItem[] = BG_COLORS.map((c, i) => ({
      id: `bg-${i + 1}`,
      name: c.name,
      dataUrl: '',
      rarity: 50,
    }));
    return [
      { id: 'layer-background', name: 'BACKGROUND', items: bgItems, collapsed: false, order: 0 },
      { id: 'layer-base', name: 'BASE', items: BASE_DEMO_ITEMS, collapsed: false, order: 1 },
      { id: 'layer-beak', name: 'BEAK', items: BEAK_DEMO_ITEMS, collapsed: false, order: 2 },
      { id: 'layer-eyes', name: 'EYES', items: EYES_DEMO_ITEMS, collapsed: false, order: 3 },
    ];
  });
  const [newLayerName, setNewLayerName] = useState('');
  const [preview, setPreview] = useState<string | null>(null);
  const [generating, setGenerating] = useState(false);
  const [currentPicks, setCurrentPicks] = useState<Record<string, LayerItem | null>>({});
  const [bulkCount, setBulkCount] = useState(10);
  const [bulkProgress, setBulkProgress] = useState<number | null>(null);
  const [activeTab, setActiveTab] = useState<'layers' | 'export'>('layers');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Populate canvas-generated background color data URLs after client mount
  useEffect(() => {
    setLayers((prev) =>
      prev.map((layer) => {
        if (layer.id !== 'layer-background') return layer;
        return {
          ...layer,
          items: layer.items.map((item, i) => ({
            ...item,
            dataUrl: makeSolidColorDataUrl(BG_COLORS[i]?.hex ?? '#000000'),
          })),
        };
      })
    );
  }, []);

  const hasLayers = layers.some((l) => l.items.length > 0);
  const totalItems = layers.reduce((s, l) => s + l.items.length, 0);
  const maxCombos = layers.reduce((acc, l) => {
    const c = l.items.length;
    return c > 0 ? acc * c : acc;
  }, 1);

  // ── Layer helpers ─────────────────────────────────────────────────────────

  function addLayer(name: string) {
    const trimmed = name.trim();
    if (!trimmed || layers.length >= MAX_LAYERS) return;
    setLayers((prev) => [...prev, { id: uid(), name: trimmed, items: [], collapsed: false, order: prev.length }]);
    setNewLayerName('');
  }

  function removeLayer(id: string) {
    setLayers((prev) => prev.filter((l) => l.id !== id));
  }

  function toggleCollapse(id: string) {
    setLayers((prev) => prev.map((l) => l.id === id ? { ...l, collapsed: !l.collapsed } : l));
  }

  function renameLayer(id: string, name: string) {
    setLayers((prev) => prev.map((l) => l.id === id ? { ...l, name } : l));
  }

  function moveLayer(id: string, dir: -1 | 1) {
    setLayers((prev) => {
      const idx = prev.findIndex((l) => l.id === id);
      const next = idx + dir;
      if (next < 0 || next >= prev.length) return prev;
      const arr = [...prev];
      [arr[idx], arr[next]] = [arr[next], arr[idx]];
      return arr;
    });
  }

  // ── Item helpers ──────────────────────────────────────────────────────────

  function handleFileUpload(layerId: string, files: FileList | null) {
    if (!files) return;
    const readers: Promise<LayerItem>[] = Array.from(files)
      .filter((f) => f.type === 'image/png')
      .map((file) => new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve({
          id: uid(),
          name: file.name.replace(/\.png$/i, ''),
          dataUrl: e.target?.result as string,
          rarity: 50,
        });
        reader.readAsDataURL(file);
      }));
    Promise.all(readers).then((newItems) => {
      setLayers((prev) => prev.map((l) => l.id === layerId ? { ...l, items: [...l.items, ...newItems] } : l));
    });
  }

  function removeItem(layerId: string, itemId: string) {
    setLayers((prev) => prev.map((l) => l.id === layerId ? { ...l, items: l.items.filter((i) => i.id !== itemId) } : l));
  }

  function updateRarity(layerId: string, itemId: string, rarity: number) {
    setLayers((prev) => prev.map((l) =>
      l.id === layerId ? { ...l, items: l.items.map((i) => i.id === itemId ? { ...i, rarity } : i) } : l
    ));
  }

  function renameItem(layerId: string, itemId: string, name: string) {
    setLayers((prev) => prev.map((l) =>
      l.id === layerId ? { ...l, items: l.items.map((i) => i.id === itemId ? { ...i, name } : i) } : l
    ));
  }

  // ── Generation ────────────────────────────────────────────────────────────

  const generateOne = useCallback(async () => {
    if (!hasLayers) return;
    setGenerating(true);
    const picks: Record<string, LayerItem | null> = {};
    const orderedPicks: (LayerItem | null)[] = [];
    for (const layer of layers) {
      const pick = weightedPick(layer.items);
      picks[layer.id] = pick;
      orderedPicks.push(pick);
    }
    setCurrentPicks(picks);
    const dataUrl = await compositeImages(orderedPicks);
    setPreview(dataUrl);
    setGenerating(false);
  }, [layers, hasLayers]);

  const downloadCurrent = useCallback(() => {
    if (!preview) return;
    const a = document.createElement('a');
    a.href = preview;
    a.download = `regal-eagle-${Date.now()}.png`;
    a.click();
  }, [preview]);

  const generateBulk = useCallback(async () => {
    if (!hasLayers || bulkCount < 1) return;
    setGenerating(true);
    const JSZip = (await import('jszip')).default;
    const zip = new JSZip();
    for (let i = 0; i < bulkCount; i++) {
      setBulkProgress(i + 1);
      const orderedPicks: (LayerItem | null)[] = layers.map((l) => weightedPick(l.items));
      const dataUrl = await compositeImages(orderedPicks);
      const base64 = dataUrl.split(',')[1];
      zip.file(`regal-eagle-${String(i + 1).padStart(4, '0')}.png`, base64, { base64: true });
    }
    const blob = await zip.generateAsync({ type: 'blob' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `regal-eagles-collection-${bulkCount}.zip`;
    a.click();
    URL.revokeObjectURL(url);
    setBulkProgress(null);
    setGenerating(false);
  }, [layers, hasLayers, bulkCount]);

  function handleDrop(layerId: string, e: React.DragEvent) {
    e.preventDefault();
    handleFileUpload(layerId, e.dataTransfer.files);
  }

  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <div className="bg-mesh" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: 'var(--font-sans)' }}>

      {/* ══════════════════════════════════════════════════════════════════════
          HEADER / NAV
      ══════════════════════════════════════════════════════════════════════ */}
      <header style={{
        position: 'sticky', top: 0, zIndex: 50,
        background: 'rgba(10,13,22,0.92)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(251,191,36,0.12)',
      }}>
        <div style={{
          maxWidth: '1280px', margin: '0 auto',
          padding: '0 24px',
          height: '68px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          {/* Brand */}
          <a href="#" style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
            <EagleIcon size={34} />
            <div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '7px' }}>
                <span className="text-gold-gradient" style={{ fontSize: '19px', fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1 }}>
                  Regal Eagles
                </span>
                <span style={{ fontSize: '10px', color: 'rgba(251,191,36,0.5)', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase' }}>
                  by Reagles Inc
                </span>
              </div>
              <div style={{ fontSize: '10px', color: 'hsl(var(--muted-foreground))', marginTop: '1px', letterSpacing: '0.04em' }}>
                NFT Layer Randomizer
              </div>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav style={{ display: 'flex', alignItems: 'center', gap: '4px' }} aria-label="Main navigation">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                style={{
                  padding: '8px 16px', borderRadius: '10px',
                  fontSize: '14px', fontWeight: 500,
                  color: 'hsl(var(--muted-foreground))',
                  textDecoration: 'none',
                  transition: 'all 0.15s',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#fbbf24'; e.currentTarget.style.background = 'rgba(251,191,36,0.07)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'hsl(var(--muted-foreground))'; e.currentTarget.style.background = 'transparent'; }}
              >
                {link.label}
              </a>
            ))}
            <a
              href="mailto:mail@regaleagles.org"
              className="btn-gold"
              style={{
                marginLeft: '8px',
                padding: '9px 20px', borderRadius: '10px',
                fontSize: '13px', fontWeight: 700,
                textDecoration: 'none',
                display: 'inline-flex', alignItems: 'center', gap: '6px',
              }}
            >
              Get in Touch
            </a>
          </nav>

          {/* Mobile menu toggle */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              display: 'none',
              background: 'none', border: 'none', cursor: 'pointer',
              color: 'hsl(var(--foreground))', padding: '6px',
            }}
            aria-label="Toggle menu"
            className="mobile-menu-btn"
          >
            {mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>

        {/* Mobile Nav Dropdown */}
        {mobileMenuOpen && (
          <div style={{
            borderTop: '1px solid rgba(251,191,36,0.1)',
            padding: '12px 24px 16px',
            display: 'flex', flexDirection: 'column', gap: '4px',
          }}>
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMobileMenuOpen(false)}
                style={{
                  padding: '10px 14px', borderRadius: '10px',
                  fontSize: '15px', fontWeight: 500,
                  color: 'hsl(var(--foreground))',
                  textDecoration: 'none',
                  transition: 'background 0.15s',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(251,191,36,0.07)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
              >
                {link.label}
              </a>
            ))}
          </div>
        )}
      </header>

      {/* ══════════════════════════════════════════════════════════════════════
          HERO SECTION
      ══════════════════════════════════════════════════════════════════════ */}
      <section id="about" style={{
        maxWidth: '1280px', margin: '0 auto',
        padding: '72px 24px 56px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '64px',
        alignItems: 'center',
      }}>
        {/* Left: Copy */}
        <div>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '7px',
            padding: '5px 14px', borderRadius: '99px',
            background: 'rgba(251,191,36,0.1)',
            border: '1px solid rgba(251,191,36,0.25)',
            marginBottom: '24px',
          }}>
            <SparklesIcon size={12} />
            <span style={{ fontSize: '11px', fontWeight: 700, color: '#fbbf24', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
              NFT Layer Randomizer
            </span>
          </div>

          <h1 style={{
            fontSize: 'clamp(36px, 5vw, 56px)',
            fontWeight: 800,
            letterSpacing: '-0.04em',
            lineHeight: 1.08,
            margin: '0 0 20px',
            color: 'hsl(var(--foreground))',
          }}>
            Build Your{' '}
            <span className="text-gold-gradient">Regal Eagles</span>{' '}
            Collection
          </h1>

          <p style={{
            fontSize: '17px',
            color: 'hsl(var(--muted-foreground))',
            lineHeight: 1.65,
            margin: '0 0 32px',
            maxWidth: '480px',
          }}>
            Layer-by-layer NFT generation with weighted rarity controls. Upload your own PNG traits, set custom rarities, and export your entire collection as a ZIP — all in your browser.
          </p>

          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <a
              href="#randomizer"
              className="btn-gold"
              style={{
                padding: '13px 28px', borderRadius: '12px',
                fontSize: '15px', fontWeight: 700,
                textDecoration: 'none',
                display: 'inline-flex', alignItems: 'center', gap: '8px',
              }}
            >
              <ShuffleIcon size={16} /> Try the Randomizer
            </a>
            <a
              href="#collection"
              style={{
                padding: '13px 24px', borderRadius: '12px',
                fontSize: '15px', fontWeight: 600,
                textDecoration: 'none',
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                border: '1px solid hsl(var(--border))',
                color: 'hsl(var(--foreground))',
                transition: 'all 0.15s',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(251,191,36,0.4)'; e.currentTarget.style.color = '#fbbf24'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'hsl(var(--border))'; e.currentTarget.style.color = 'hsl(var(--foreground))'; }}
            >
              View Sample
            </a>
          </div>

          {/* Stats row */}
          <div style={{ display: 'flex', gap: '32px', marginTop: '40px', paddingTop: '32px', borderTop: '1px solid hsl(var(--border))' }}>
            {[
              { value: '5', label: 'Max Layers' },
              { value: '500', label: 'Bulk Export' },
              { value: '∞', label: 'Combinations' },
            ].map((s) => (
              <div key={s.label}>
                <div className="text-gold-gradient" style={{ fontSize: '28px', fontWeight: 800, fontFamily: 'var(--font-mono)', lineHeight: 1 }}>{s.value}</div>
                <div style={{ fontSize: '12px', color: 'hsl(var(--muted-foreground))', marginTop: '4px', fontWeight: 500 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Auto-rotating preview */}
        <div id="collection" style={{ display: 'flex', justifyContent: 'center' }}>
          <AutoPreview layers={layers} />
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════════════
          RANDOMIZER TOOL SECTION
      ══════════════════════════════════════════════════════════════════════ */}
      <section id="randomizer" style={{
        borderTop: '1px solid hsl(var(--border))',
        background: 'rgba(14,17,27,0.6)',
      }}>
        {/* Section header */}
        <div style={{
          maxWidth: '1280px', margin: '0 auto',
          padding: '48px 24px 32px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: '16px',
        }}>
          <div>
            <h2 style={{ fontSize: '28px', fontWeight: 800, letterSpacing: '-0.03em', margin: '0 0 6px', color: 'hsl(var(--foreground))' }}>
              NFT Layer Randomizer
            </h2>
            <p style={{ fontSize: '14px', color: 'hsl(var(--muted-foreground))', margin: 0 }}>
              Upload PNG traits, set rarities, and generate your collection
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '8px', background: 'rgba(251,191,36,0.08)', border: '1px solid rgba(251,191,36,0.15)' }}>
              <LayersIcon size={12} />
              <span style={{ fontSize: '12px', color: 'hsl(var(--muted-foreground))' }}>{layers.length}/{MAX_LAYERS} layers</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '8px', background: 'rgba(251,191,36,0.08)', border: '1px solid rgba(251,191,36,0.15)' }}>
              <SparklesIcon size={12} />
              <span style={{ fontSize: '12px', color: 'hsl(var(--muted-foreground))' }}>
                {hasLayers ? maxCombos.toLocaleString() : '0'} combos
              </span>
            </div>
            <button
              onClick={generateOne}
              disabled={!hasLayers || generating}
              className="btn-gold"
              style={{ display: 'flex', alignItems: 'center', gap: '7px', padding: '9px 20px', borderRadius: '10px', fontSize: '14px', border: 'none', cursor: 'pointer' }}>
              <ShuffleIcon size={15} />
              Randomize
            </button>
          </div>
        </div>

        {/* Tool body */}
        <div style={{
          maxWidth: '1280px', margin: '0 auto',
          padding: '0 24px 56px',
          display: 'flex', gap: '0', borderRadius: '16px', overflow: 'hidden',
          border: '1px solid hsl(var(--border))',
          background: 'hsl(var(--card))',
        }}>

          {/* ── Left Panel ── */}
          <aside style={{
            width: '360px', minWidth: '300px', maxWidth: '400px',
            display: 'flex', flexDirection: 'column',
            borderRight: '1px solid hsl(var(--border))',
            background: 'hsl(var(--card))',
          }}>
            {/* Panel Tabs */}
            <div style={{ display: 'flex', borderBottom: '1px solid hsl(var(--border))', padding: '0 16px' }}>
              {(['layers', 'export'] as const).map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  style={{
                    padding: '14px 14px',
                    fontSize: '12px', fontWeight: 600,
                    letterSpacing: '0.04em', textTransform: 'uppercase',
                    background: 'none', border: 'none', cursor: 'pointer',
                    borderBottom: activeTab === tab ? '2px solid var(--gold)' : '2px solid transparent',
                    color: activeTab === tab ? 'var(--gold)' : 'hsl(var(--muted-foreground))',
                    transition: 'color 0.15s', marginBottom: '-1px',
                  }}>
                  {tab === 'layers' ? `Layers (${layers.length})` : 'Export'}
                </button>
              ))}
            </div>

            {activeTab === 'layers' && (
              <>
                {/* Add Layer */}
                <div style={{ padding: '14px 16px', borderBottom: '1px solid hsl(var(--border))' }}>
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
                    <input
                      style={{
                        flex: 1, padding: '8px 12px', borderRadius: '10px',
                        border: '1px solid hsl(var(--border))',
                        background: 'hsl(var(--secondary))',
                        color: 'hsl(var(--foreground))',
                        fontSize: '13px', outline: 'none',
                        fontFamily: 'var(--font-sans)',
                      }}
                      placeholder={layers.length >= MAX_LAYERS ? 'Max 5 layers reached' : 'New layer name…'}
                      value={newLayerName}
                      disabled={layers.length >= MAX_LAYERS}
                      onChange={(e) => setNewLayerName(e.target.value)}
                      onKeyDown={(e) => { if (e.key === 'Enter') addLayer(newLayerName); }}
                    />
                    <button
                      onClick={() => addLayer(newLayerName)}
                      disabled={layers.length >= MAX_LAYERS || !newLayerName.trim()}
                      className="btn-gold"
                      style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '8px 14px', borderRadius: '10px', fontSize: '12px', fontWeight: 700, border: 'none', cursor: 'pointer' }}>
                      <PlusIcon size={14} /> Add
                    </button>
                  </div>
                  <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                    {Array.from({ length: MAX_LAYERS }).map((_, i) => (
                      <div key={i} style={{
                        flex: 1, height: '3px', borderRadius: '99px',
                        background: i < layers.length ? LAYER_COLORS[i % LAYER_COLORS.length].dot : 'hsl(var(--border))',
                        transition: 'background 0.3s',
                      }} />
                    ))}
                    <span style={{ fontSize: '10px', color: 'hsl(var(--muted-foreground))', marginLeft: '6px', whiteSpace: 'nowrap' }}>
                      {layers.length}/{MAX_LAYERS}
                    </span>
                  </div>
                </div>

                {/* Layer List */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '10px', maxHeight: '560px' }}>
                  {layers.length === 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 16px', gap: '12px', color: 'hsl(var(--muted-foreground))' }}>
                      <LayersIcon size={36} />
                      <p style={{ fontSize: '13px', textAlign: 'center', margin: 0 }}>Add your first layer above.<br />Layers stack back-to-front.</p>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {layers.map((layer, idx) => (
                        <LayerPanel
                          key={layer.id}
                          layer={layer}
                          index={idx}
                          colorScheme={LAYER_COLORS[idx % LAYER_COLORS.length]}
                          currentPick={currentPicks[layer.id] ?? null}
                          isFirst={idx === 0}
                          isLast={idx === layers.length - 1}
                          onToggleCollapse={() => toggleCollapse(layer.id)}
                          onRename={(name) => renameLayer(layer.id, name)}
                          onRemove={() => removeLayer(layer.id)}
                          onMoveUp={() => moveLayer(layer.id, -1)}
                          onMoveDown={() => moveLayer(layer.id, 1)}
                          onFileUpload={(files) => handleFileUpload(layer.id, files)}
                          onDrop={(e) => handleDrop(layer.id, e)}
                          onRemoveItem={(itemId) => removeItem(layer.id, itemId)}
                          onUpdateRarity={(itemId, r) => updateRarity(layer.id, itemId, r)}
                          onRenameItem={(itemId, name) => renameItem(layer.id, itemId, name)}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}

            {activeTab === 'export' && (
              <ExportPanel
                hasLayers={hasLayers}
                generating={generating}
                bulkCount={bulkCount}
                bulkProgress={bulkProgress}
                maxCombos={maxCombos}
                totalItems={totalItems}
                layers={layers}
                preview={preview}
                onBulkCountChange={setBulkCount}
                onGenerateBulk={generateBulk}
                onDownloadCurrent={downloadCurrent}
                onGenerateOne={generateOne}
              />
            )}
          </aside>

          {/* ── Right Panel: Preview ── */}
          <main style={{
            flex: 1, display: 'flex', flexDirection: 'column',
            background: 'hsl(var(--background))',
            minHeight: '560px',
          }}>
            <PreviewPanel
              preview={preview}
              generating={generating}
              bulkProgress={bulkProgress}
              bulkCount={bulkCount}
              hasLayers={hasLayers}
              layers={layers}
              currentPicks={currentPicks}
              onGenerate={generateOne}
              onDownload={downloadCurrent}
            />
          </main>
        </div>
      </section>

      {/* ══════════════════════════════════════════════════════════════════════
          FOOTER
      ══════════════════════════════════════════════════════════════════════ */}
      <footer id="contact" style={{
        borderTop: '1px solid hsl(var(--border))',
        background: 'rgba(8,10,18,0.95)',
        marginTop: 'auto',
      }}>
        <div style={{
          maxWidth: '1280px', margin: '0 auto',
          padding: '56px 24px 32px',
        }}>
          {/* Footer top grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1fr 1fr',
            gap: '48px',
            marginBottom: '48px',
          }}>
            {/* Brand column */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                <EagleIcon size={28} />
                <span className="text-gold-gradient" style={{ fontSize: '18px', fontWeight: 800, letterSpacing: '-0.03em' }}>
                  Regal Eagles
                </span>
              </div>
              <p style={{ fontSize: '13px', color: 'hsl(var(--muted-foreground))', lineHeight: 1.7, margin: '0 0 20px', maxWidth: '280px' }}>
                Professional NFT layer randomizer and collection generator by Reagles Inc. Build, preview, and export your entire NFT collection with ease.
              </p>
              {/* Contact info */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                  <MapPinIcon size={14} />
                  <span style={{ fontSize: '12px', color: 'hsl(var(--muted-foreground))', lineHeight: 1.5 }}>
                    584 Castro St #4071<br />San Francisco, CA 94114
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <MailIcon size={14} />
                  <a
                    href="mailto:mail@regaleagles.org"
                    style={{ fontSize: '12px', color: '#fbbf24', textDecoration: 'none', transition: 'opacity 0.15s' }}
                    onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.75'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
                  >
                    mail@regaleagles.org
                  </a>
                </div>
              </div>
            </div>

            {/* Product links */}
            <div>
              <h3 style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'hsl(var(--muted-foreground))', margin: '0 0 16px' }}>
                Product
              </h3>
              <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {['Randomizer Tool', 'Layer Manager', 'Bulk Export', 'Rarity Controls'].map((item) => (
                  <li key={item}>
                    <a
                      href="#randomizer"
                      style={{ fontSize: '13px', color: 'hsl(var(--muted-foreground))', textDecoration: 'none', transition: 'color 0.15s' }}
                      onMouseEnter={(e) => { e.currentTarget.style.color = '#fbbf24'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = 'hsl(var(--muted-foreground))'; }}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company links */}
            <div>
              <h3 style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'hsl(var(--muted-foreground))', margin: '0 0 16px' }}>
                Company
              </h3>
              <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {['About Us', 'Our Collection', 'Blog', 'Press'].map((item) => (
                  <li key={item}>
                    <a
                      href="#about"
                      style={{ fontSize: '13px', color: 'hsl(var(--muted-foreground))', textDecoration: 'none', transition: 'color 0.15s' }}
                      onMouseEnter={(e) => { e.currentTarget.style.color = '#fbbf24'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = 'hsl(var(--muted-foreground))'; }}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support links */}
            <div>
              <h3 style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'hsl(var(--muted-foreground))', margin: '0 0 16px' }}>
                Support
              </h3>
              <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {['Help Center', 'Contact Us', 'Privacy Policy', 'Terms of Service'].map((item) => (
                  <li key={item}>
                    <a
                      href="#contact"
                      style={{ fontSize: '13px', color: 'hsl(var(--muted-foreground))', textDecoration: 'none', transition: 'color 0.15s' }}
                      onMouseEnter={(e) => { e.currentTarget.style.color = '#fbbf24'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = 'hsl(var(--muted-foreground))'; }}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Footer bottom bar */}
          <div style={{
            paddingTop: '24px',
            borderTop: '1px solid hsl(var(--border))',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            flexWrap: 'wrap', gap: '12px',
          }}>
            <p style={{ fontSize: '12px', color: 'hsl(var(--muted-foreground))', margin: 0 }}>
              © {new Date().getFullYear()} Regal Eagles by Reagles Inc. All rights reserved.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#4ade80', boxShadow: '0 0 6px #4ade80' }} />
              <span style={{ fontSize: '11px', color: 'hsl(var(--muted-foreground))' }}>
                regaleagles.org
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

// ─── Layer Panel ──────────────────────────────────────────────────────────────

interface LayerPanelProps {
  layer: Layer;
  index: number;
  colorScheme: { badge: string; dot: string; label: string };
  currentPick: LayerItem | null;
  isFirst: boolean;
  isLast: boolean;
  onToggleCollapse: () => void;
  onRename: (name: string) => void;
  onRemove: () => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onFileUpload: (files: FileList | null) => void;
  onDrop: (e: React.DragEvent) => void;
  onRemoveItem: (itemId: string) => void;
  onUpdateRarity: (itemId: string, rarity: number) => void;
  onRenameItem: (itemId: string, name: string) => void;
}

function LayerPanel({
  layer, index, colorScheme, currentPick, isFirst, isLast,
  onToggleCollapse, onRename, onRemove, onMoveUp, onMoveDown,
  onFileUpload, onDrop, onRemoveItem, onUpdateRarity, onRenameItem,
}: LayerPanelProps) {
  const [dragging, setDragging] = useState(false);
  const [editingName, setEditingName] = useState(false);
  const [nameVal, setNameVal] = useState(layer.name);
  const fileInputId = `file-input-${layer.id}`;

  return (
    <div style={{
      borderRadius: '12px',
      border: `1px solid hsl(var(--border))`,
      background: 'hsl(var(--secondary))',
      overflow: 'hidden',
      transition: 'border-color 0.2s',
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: '8px',
        padding: '9px 10px',
        background: 'rgba(255,255,255,0.02)',
        borderBottom: layer.collapsed ? 'none' : '1px solid hsl(var(--border))',
      }}>
        <div style={{
          width: '22px', height: '22px', borderRadius: '6px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '11px', fontWeight: 700, flexShrink: 0,
          background: `${colorScheme.dot}22`,
          color: colorScheme.dot,
          border: `1px solid ${colorScheme.dot}44`,
          fontFamily: 'var(--font-mono)',
        }}>
          {index + 1}
        </div>

        {editingName ? (
          <input
            autoFocus
            style={{
              flex: 1, fontSize: '13px', fontWeight: 600,
              background: 'hsl(var(--card))', color: 'hsl(var(--foreground))',
              border: '1px solid hsl(var(--input))', borderRadius: '6px',
              padding: '2px 6px', outline: 'none', fontFamily: 'var(--font-sans)',
            }}
            value={nameVal}
            onChange={(e) => setNameVal(e.target.value)}
            onBlur={() => { onRename(nameVal || layer.name); setEditingName(false); }}
            onKeyDown={(e) => { if (e.key === 'Enter') { onRename(nameVal || layer.name); setEditingName(false); } }}
          />
        ) : (
          <span
            style={{ flex: 1, fontSize: '13px', fontWeight: 600, color: 'hsl(var(--foreground))', cursor: 'text', letterSpacing: '-0.01em' }}
            onDoubleClick={() => setEditingName(true)}>
            {layer.name}
          </span>
        )}

        <span className={colorScheme.badge} style={{
          fontSize: '10px', fontWeight: 700, padding: '2px 7px', borderRadius: '99px',
          border: '1px solid', fontFamily: 'var(--font-mono)',
        }}>
          {layer.items.length}
        </span>

        <div style={{ display: 'flex', gap: '1px' }}>
          <button onClick={onMoveUp} disabled={isFirst} style={{ background: 'none', border: 'none', cursor: isFirst ? 'default' : 'pointer', padding: '3px', color: 'hsl(var(--muted-foreground))', opacity: isFirst ? 0.3 : 0.7, borderRadius: '4px' }} title="Move layer up">
            <ChevronUpIcon size={12} />
          </button>
          <button onClick={onMoveDown} disabled={isLast} style={{ background: 'none', border: 'none', cursor: isLast ? 'default' : 'pointer', padding: '3px', color: 'hsl(var(--muted-foreground))', opacity: isLast ? 0.3 : 0.7, borderRadius: '4px' }} title="Move layer down">
            <ChevronDownIcon size={12} />
          </button>
        </div>

        <button onClick={onToggleCollapse} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '3px', color: 'hsl(var(--muted-foreground))', borderRadius: '4px' }}>
          {layer.collapsed ? <ChevronDownIcon size={13} /> : <ChevronUpIcon size={13} />}
        </button>

        <button
          onClick={onRemove}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '3px', color: 'hsl(var(--destructive))', opacity: 0.6, borderRadius: '4px', transition: 'opacity 0.15s' }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.6')}>
          <TrashIcon size={13} />
        </button>
      </div>

      {!layer.collapsed && (
        <div style={{ padding: '10px' }}>
          <div
            style={{
              borderRadius: '10px',
              border: `2px dashed ${dragging ? colorScheme.dot : 'hsl(var(--border))'}`,
              background: dragging ? `${colorScheme.dot}0d` : 'transparent',
              padding: '14px 10px',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px',
              cursor: 'pointer', transition: 'all 0.15s', marginBottom: '8px',
            }}
            onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
            onDragLeave={() => setDragging(false)}
            onDrop={(e) => { setDragging(false); onDrop(e); }}
            onClick={() => document.getElementById(fileInputId)?.click()}>
            <UploadIcon size={16} />
            <span style={{ fontSize: '11px', color: 'hsl(var(--muted-foreground))', textAlign: 'center' }}>
              Drop PNGs or <span style={{ color: colorScheme.dot, fontWeight: 600 }}>click to upload</span>
            </span>
            <input id={fileInputId} type="file" accept="image/png" multiple className="hidden" onChange={(e) => onFileUpload(e.target.files)} />
          </div>

          {layer.items.length > 0 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {layer.items.map((item) => (
                <ItemRow
                  key={item.id}
                  item={item}
                  isActive={currentPick?.id === item.id}
                  accentColor={colorScheme.dot}
                  totalRarity={layer.items.reduce((s, i) => s + i.rarity, 0)}
                  onRemove={() => onRemoveItem(item.id)}
                  onUpdateRarity={(r) => onUpdateRarity(item.id, r)}
                  onRename={(name) => onRenameItem(item.id, name)}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ─── Item Row ─────────────────────────────────────────────────────────────────

interface ItemRowProps {
  item: LayerItem;
  isActive: boolean;
  accentColor: string;
  totalRarity: number;
  onRemove: () => void;
  onUpdateRarity: (r: number) => void;
  onRename: (name: string) => void;
}

function ItemRow({ item, isActive, accentColor, totalRarity, onRemove, onUpdateRarity, onRename }: ItemRowProps) {
  const [editingName, setEditingName] = useState(false);
  const [nameVal, setNameVal] = useState(item.name);
  const pct = totalRarity > 0 ? ((item.rarity / totalRarity) * 100).toFixed(1) : '0.0';

  return (
    <div
      className={isActive ? 'active-item' : ''}
      style={{
        borderRadius: '10px',
        border: `1px solid ${isActive ? accentColor + '55' : 'hsl(var(--border))'}`,
        background: isActive ? `${accentColor}0d` : 'hsl(var(--card))',
        padding: '8px 10px',
        transition: 'all 0.2s',
      }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{
          width: '36px', height: '36px', borderRadius: '8px', flexShrink: 0, overflow: 'hidden',
          border: '1px solid hsl(var(--border))',
          backgroundImage: 'linear-gradient(45deg,#1e2235 25%,transparent 25%),linear-gradient(-45deg,#1e2235 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#1e2235 75%),linear-gradient(-45deg,transparent 75%,#1e2235 75%)',
          backgroundSize: '8px 8px',
          backgroundPosition: '0 0,0 4px,4px -4px,-4px 0',
          backgroundColor: '#171b2a',
        }}>
          {item.dataUrl ? <img src={item.dataUrl} alt={`Trait: ${item.name}`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : null}
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          {editingName ? (
            <input
              autoFocus
              style={{
                width: '100%', fontSize: '12px', fontWeight: 600,
                background: 'hsl(var(--secondary))', color: 'hsl(var(--foreground))',
                border: '1px solid hsl(var(--input))', borderRadius: '5px',
                padding: '2px 5px', outline: 'none', fontFamily: 'var(--font-sans)',
              }}
              value={nameVal}
              onChange={(e) => setNameVal(e.target.value)}
              onBlur={() => { onRename(nameVal || item.name); setEditingName(false); }}
              onKeyDown={(e) => { if (e.key === 'Enter') { onRename(nameVal || item.name); setEditingName(false); } }}
            />
          ) : (
            <p
              style={{ fontSize: '12px', fontWeight: 600, color: 'hsl(var(--foreground))', margin: 0, cursor: 'text', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
              onDoubleClick={() => setEditingName(true)}
              title="Double-click to rename">
              {item.name}
            </p>
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px' }}>
            <span style={{ fontSize: '10px', color: 'hsl(var(--muted-foreground))', fontFamily: 'var(--font-mono)' }}>w:{item.rarity}</span>
            <span style={{ fontSize: '10px', fontWeight: 700, color: accentColor, fontFamily: 'var(--font-mono)' }}>{pct}%</span>
            {isActive && (
              <span style={{ fontSize: '9px', padding: '1px 5px', borderRadius: '99px', background: `${accentColor}22`, color: accentColor, fontWeight: 700, letterSpacing: '0.05em' }}>ACTIVE</span>
            )}
          </div>
        </div>

        <button
          onClick={onRemove}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: 'hsl(var(--muted-foreground))', opacity: 0.5, borderRadius: '5px', transition: 'opacity 0.15s', flexShrink: 0 }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.5')}>
          <TrashIcon size={12} />
        </button>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
        <span style={{ fontSize: '10px', color: 'hsl(var(--muted-foreground))', width: '36px', textAlign: 'right', flexShrink: 0 }}>Rarity</span>
        <input type="range" min={1} max={100} value={item.rarity} onChange={(e) => onUpdateRarity(Number(e.target.value))} style={{ flex: 1, accentColor }} />
        <span style={{ fontSize: '11px', fontWeight: 600, color: 'hsl(var(--foreground))', width: '24px', textAlign: 'right', fontFamily: 'var(--font-mono)', flexShrink: 0 }}>{item.rarity}</span>
      </div>

      <div style={{ marginTop: '4px', height: '3px', borderRadius: '99px', background: 'hsl(var(--border))', overflow: 'hidden' }}>
        <div style={{ height: '100%', borderRadius: '99px', width: `${pct}%`, background: accentColor, transition: 'width 0.2s' }} />
      </div>
    </div>
  );
}

// ─── Preview Panel ────────────────────────────────────────────────────────────

interface PreviewPanelProps {
  preview: string | null;
  generating: boolean;
  bulkProgress: number | null;
  bulkCount: number;
  hasLayers: boolean;
  layers: Layer[];
  currentPicks: Record<string, LayerItem | null>;
  onGenerate: () => void;
  onDownload: () => void;
}

function PreviewPanel({ preview, generating, bulkProgress, bulkCount, hasLayers, layers, currentPicks, onGenerate, onDownload }: PreviewPanelProps) {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px', gap: '20px', overflowY: 'auto' }}>
      <div style={{
        position: 'relative',
        width: '100%', maxWidth: '480px', aspectRatio: '1 / 1',
        borderRadius: '20px', overflow: 'hidden',
        border: preview ? '1px solid rgba(251,191,36,0.3)' : '1px solid hsl(var(--border))',
        boxShadow: preview ? 'var(--shadow-gold)' : 'var(--shadow-md)',
        transition: 'all 0.3s',
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'linear-gradient(45deg,#1e2235 25%,transparent 25%),linear-gradient(-45deg,#1e2235 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#1e2235 75%),linear-gradient(-45deg,transparent 75%,#1e2235 75%)',
          backgroundSize: '16px 16px',
          backgroundPosition: '0 0,0 8px,8px -8px,-8px 0',
          backgroundColor: '#171b2a',
        }} />

        {generating && (
          <div style={{
            position: 'absolute', inset: 0, zIndex: 10,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px',
            background: 'rgba(14,17,27,0.8)', backdropFilter: 'blur(4px)',
          }}>
            <div className="animate-spin" style={{ width: '40px', height: '40px', borderRadius: '50%', border: '3px solid rgba(251,191,36,0.2)', borderTopColor: 'var(--gold)' }} />
            {bulkProgress !== null && (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '20px', fontWeight: 800, color: 'var(--gold)', fontFamily: 'var(--font-mono)' }}>{bulkProgress}/{bulkCount}</div>
                <div style={{ fontSize: '11px', color: 'hsl(var(--muted-foreground))' }}>Generating NFTs…</div>
                <div style={{ marginTop: '8px', width: '120px', height: '3px', borderRadius: '99px', background: 'hsl(var(--border))' }}>
                  <div style={{ height: '100%', borderRadius: '99px', background: 'var(--gold)', width: `${(bulkProgress / bulkCount) * 100}%`, transition: 'width 0.1s' }} />
                </div>
              </div>
            )}
          </div>
        )}

        {preview ? (
          <img
            src={preview}
            alt="Generated Regal Eagle NFT composite preview"
            className="animate-fade-in"
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain' }}
          />
        ) : (
          <div style={{
            position: 'absolute', inset: 0,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '16px',
            color: 'hsl(var(--muted-foreground))',
          }}>
            <div style={{ fontSize: '56px', lineHeight: 1 }}>🦅</div>
            <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '15px', fontWeight: 600, color: 'hsl(var(--foreground))', margin: '0 0 4px' }}>
                {hasLayers ? 'Ready to generate' : 'Add layers to begin'}
              </p>
              <p style={{ fontSize: '12px', margin: 0 }}>
                {hasLayers ? 'Hit Randomize to create your first Regal Eagle' : 'Upload PNGs to each layer, then randomize'}
              </p>
            </div>
            {hasLayers && (
              <button onClick={onGenerate} className="btn-gold" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 24px', borderRadius: '12px', fontSize: '14px', border: 'none', cursor: 'pointer' }}>
                <ShuffleIcon size={16} /> Randomize
              </button>
            )}
          </div>
        )}
      </div>

      {preview && Object.keys(currentPicks).length > 0 && (
        <div className="animate-fade-in" style={{
          width: '100%', maxWidth: '480px',
          borderRadius: '16px', border: '1px solid hsl(var(--border))',
          background: 'hsl(var(--card))', padding: '16px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '12px' }}>
            <SparklesIcon size={12} />
            <span style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'hsl(var(--muted-foreground))' }}>Current Combo</span>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {layers.map((layer, idx) => {
              const pick = currentPicks[layer.id];
              if (!pick) return null;
              const total = layer.items.reduce((s, i) => s + i.rarity, 0);
              const pct = total > 0 ? ((pick.rarity / total) * 100).toFixed(1) : '0.0';
              const color = LAYER_COLORS[idx % LAYER_COLORS.length].dot;
              return (
                <div key={layer.id} style={{
                  display: 'flex', alignItems: 'center', gap: '8px',
                  padding: '6px 10px', borderRadius: '10px',
                  background: `${color}12`, border: `1px solid ${color}30`,
                }}>
                  <div style={{
                    width: '28px', height: '28px', borderRadius: '6px', overflow: 'hidden', flexShrink: 0,
                    backgroundImage: 'linear-gradient(45deg,#1e2235 25%,transparent 25%),linear-gradient(-45deg,#1e2235 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#1e2235 75%),linear-gradient(-45deg,transparent 75%,#1e2235 75%)',
                    backgroundSize: '8px 8px',
                    backgroundPosition: '0 0,0 4px,4px -4px,-4px 0',
                    backgroundColor: '#171b2a',
                  }}>
                    {pick.dataUrl ? <img src={pick.dataUrl} alt={`${layer.name}: ${pick.name}`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : null}
                  </div>
                  <div>
                    <div style={{ fontSize: '10px', color: 'hsl(var(--muted-foreground))', fontWeight: 500 }}>{layer.name}</div>
                    <div style={{ fontSize: '12px', fontWeight: 700, color: 'hsl(var(--foreground))' }}>{pick.name}</div>
                  </div>
                  <div style={{ fontSize: '11px', fontWeight: 700, color, fontFamily: 'var(--font-mono)', marginLeft: '2px' }}>{pct}%</div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {hasLayers && (
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <button onClick={onGenerate} disabled={generating} className="btn-gold" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '11px 28px', borderRadius: '12px', fontSize: '14px', border: 'none', cursor: 'pointer' }}>
            <ShuffleIcon size={16} /> Randomize
          </button>
          {preview && (
            <button onClick={onDownload} className="btn-ghost" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '11px 22px', borderRadius: '12px', fontSize: '14px', cursor: 'pointer' }}>
              <DownloadIcon size={16} /> Export PNG
            </button>
          )}
        </div>
      )}
    </div>
  );
}

// ─── Export Panel ─────────────────────────────────────────────────────────────

interface ExportPanelProps {
  hasLayers: boolean;
  generating: boolean;
  bulkCount: number;
  bulkProgress: number | null;
  maxCombos: number;
  totalItems: number;
  layers: Layer[];
  preview: string | null;
  onBulkCountChange: (n: number) => void;
  onGenerateBulk: () => void;
  onDownloadCurrent: () => void;
  onGenerateOne: () => void;
}

function ExportPanel({ hasLayers, generating, bulkCount, bulkProgress, maxCombos, totalItems, layers, preview, onBulkCountChange, onGenerateBulk, onDownloadCurrent, onGenerateOne }: ExportPanelProps) {
  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '16px', display: 'flex', flexDirection: 'column', gap: '14px', maxHeight: '560px' }}>
      <div style={{ borderRadius: '12px', border: '1px solid rgba(251,191,36,0.2)', background: 'rgba(251,191,36,0.05)', padding: '14px' }}>
        <div style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'hsl(var(--muted-foreground))', marginBottom: '10px' }}>Collection Stats</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
          {[
            { label: 'Layers', value: layers.length, suffix: `/ 5` },
            { label: 'Total Traits', value: totalItems, suffix: '' },
            { label: 'Max Combos', value: hasLayers ? maxCombos.toLocaleString() : '0', suffix: '' },
            { label: 'Avg Traits/Layer', value: layers.length > 0 ? (totalItems / layers.length).toFixed(1) : '0', suffix: '' },
          ].map((stat) => (
            <div key={stat.label} style={{ borderRadius: '8px', background: 'hsl(var(--secondary))', padding: '10px 12px' }}>
              <div style={{ fontSize: '10px', color: 'hsl(var(--muted-foreground))', marginBottom: '3px' }}>{stat.label}</div>
              <div style={{ fontSize: '18px', fontWeight: 800, color: 'var(--gold)', fontFamily: 'var(--font-mono)', lineHeight: 1 }}>
                {stat.value}<span style={{ fontSize: '11px', color: 'hsl(var(--muted-foreground))', fontWeight: 500 }}>{stat.suffix}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ borderRadius: '12px', border: '1px solid hsl(var(--border))', background: 'hsl(var(--secondary))', padding: '14px' }}>
        <div style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'hsl(var(--muted-foreground))', marginBottom: '10px' }}>Layer Breakdown</div>
        {layers.length === 0 ? (
          <p style={{ fontSize: '12px', color: 'hsl(var(--muted-foreground))', margin: 0 }}>No layers yet.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {layers.map((layer, idx) => {
              const color = LAYER_COLORS[idx % LAYER_COLORS.length].dot;
              return (
                <div key={layer.id} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: color, flexShrink: 0 }} />
                  <span style={{ fontSize: '12px', fontWeight: 600, color: 'hsl(var(--foreground))', flex: 1 }}>{layer.name}</span>
                  <span style={{ fontSize: '11px', color: 'hsl(var(--muted-foreground))', fontFamily: 'var(--font-mono)' }}>{layer.items.length} traits</span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div style={{ borderRadius: '12px', border: '1px solid hsl(var(--border))', background: 'hsl(var(--secondary))', padding: '14px' }}>
        <div style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'hsl(var(--muted-foreground))', marginBottom: '10px' }}>Single NFT</div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={onGenerateOne} disabled={!hasLayers || generating} className="btn-gold" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', padding: '9px', borderRadius: '10px', fontSize: '12px', border: 'none', cursor: 'pointer' }}>
            <ShuffleIcon size={14} /> Generate
          </button>
          {preview && (
            <button onClick={onDownloadCurrent} className="btn-ghost" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', padding: '9px', borderRadius: '10px', fontSize: '12px', cursor: 'pointer' }}>
              <DownloadIcon size={14} /> Export PNG
            </button>
          )}
        </div>
      </div>

      <div style={{ borderRadius: '12px', border: '1px solid hsl(var(--border))', background: 'hsl(var(--secondary))', padding: '14px' }}>
        <div style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'hsl(var(--muted-foreground))', marginBottom: '10px' }}>Bulk Export (ZIP)</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
          <span style={{ fontSize: '12px', color: 'hsl(var(--foreground))' }}>Generate</span>
          <input
            type="number" min={1} max={500} value={bulkCount}
            onChange={(e) => onBulkCountChange(Math.max(1, Math.min(500, Number(e.target.value))))}
            style={{ width: '72px', padding: '6px 8px', borderRadius: '8px', textAlign: 'center', border: '1px solid hsl(var(--border))', background: 'hsl(var(--card))', color: 'hsl(var(--foreground))', fontSize: '13px', fontWeight: 700, fontFamily: 'var(--font-mono)', outline: 'none' }}
          />
          <span style={{ fontSize: '12px', color: 'hsl(var(--foreground))' }}>NFTs</span>
        </div>

        {bulkProgress !== null && (
          <div style={{ marginBottom: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
              <span style={{ fontSize: '11px', color: 'hsl(var(--muted-foreground))' }}>Progress</span>
              <span style={{ fontSize: '11px', fontWeight: 700, color: 'var(--gold)', fontFamily: 'var(--font-mono)' }}>{bulkProgress}/{bulkCount}</span>
            </div>
            <div style={{ height: '4px', borderRadius: '99px', background: 'hsl(var(--border))' }}>
              <div style={{ height: '100%', borderRadius: '99px', background: 'var(--gold)', width: `${(bulkProgress / bulkCount) * 100}%`, transition: 'width 0.1s' }} />
            </div>
          </div>
        )}

        <button onClick={onGenerateBulk} disabled={!hasLayers || generating} className="btn-gold" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '10px', borderRadius: '10px', fontSize: '13px', border: 'none', cursor: 'pointer' }}>
          <ZipIcon size={15} />
          {bulkProgress !== null ? `Generating ${bulkProgress}/${bulkCount}…` : `Export ${bulkCount} NFTs as ZIP`}
        </button>

        <p style={{ fontSize: '10px', color: 'hsl(var(--muted-foreground))', margin: '8px 0 0', lineHeight: 1.5 }}>
          <InfoIcon size={10} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '3px' } as React.CSSProperties} />
          Max {hasLayers ? maxCombos.toLocaleString() : '0'} unique combos. Rarity weights applied per layer.
        </p>
      </div>
    </div>
  );
}
